import { render, staticRenderFns } from "./NewDiagnose.vue?vue&type=template&id=2ebb211d&scoped=true"
import script from "./NewDiagnose.vue?vue&type=script&lang=js"
export * from "./NewDiagnose.vue?vue&type=script&lang=js"
import style0 from "./NewDiagnose.vue?vue&type=style&index=0&id=2ebb211d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb211d",
  null
  
)

export default component.exports